import { html, LitElement } from 'lit-element';
import Styles from './styles.scss';

export default class AabButton extends LitElement {
  static get properties() {
    return {
      type: {
        type: String,
        attribute: 'style-type',
      },
      large: { type: Boolean },
      fullWidth: {
        type: Boolean,
        attribute: 'full-width',
      },
      fluid: {
        type: Boolean,
        attribute: 'fluid',
      },
      iconPosition: {
        type: String,
        attribute: 'icon-position',
      },
    };
  }

  static get styles() {
    return [Styles];
  }

  constructor() {
    super();
    this.type = 'primary';
  }

  render() {
    return html`
      <div class="btn-${this.type} 
      ${this.large ? 'large' : ''}
      ${this.fullWidth ? 'full-width' : ''}
      ${this.fluid ? 'fluid' : ''}
      ${this.iconPosition === 'right' ? 'reverse' : ''}">
        <slot></slot>
      </div>
    `;
  }
}
